import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { DELETE_PROFILE_BACKGROUND } from 'root/src/shared/descriptions/endpoints/endpointIds'
import updateProfile from 'root/src/client/logic/profile/actions/updateProfile'

export const deleteProfileBackground = () => async (dispatch) => {
	const res = await dispatch(apiRequest(DELETE_PROFILE_BACKGROUND))
	dispatch(updateProfile(res.body))
}
